import { render, staticRenderFns } from "./PaymentGateway.vue?vue&type=template&id=1c4ddefe&lang=pug"
import script from "./PaymentGateway.vue?vue&type=script&lang=ts"
export * from "./PaymentGateway.vue?vue&type=script&lang=ts"
import style0 from "./PaymentGateway.vue?vue&type=style&index=0&id=1c4ddefe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports